import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Package, Truck, FileText } from "lucide-react";
import { format } from "date-fns";
import { fi } from "date-fns/locale";
import { cn } from "@/lib/utils";
import { OrderDetailData } from "@/types/orders";
import {
  ORDER_STATUS_LABELS,
  ORDER_STATUS_COLORS,
  ORDER_TYPE_LABELS,
  FULFILLMENT_TYPE_LABELS,
  OrderStatus,
  OrderType,
  FulfillmentType,
} from "@/config/order-constants";

interface OrderBasicInfoCardProps {
  order: OrderDetailData;
}

export function OrderBasicInfoCard({ order }: OrderBasicInfoCardProps) {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return "-";
    return format(new Date(dateString), "d.M.yyyy", { locale: fi });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileText className="h-5 w-5" />
          Tilauksen perustiedot
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">Tilausnumero</p>
            <p className="font-medium">{order.order_number}</p>
          </div>

          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">Tila</p>
            <Badge className={cn(ORDER_STATUS_COLORS[order.status as OrderStatus])}>
              {ORDER_STATUS_LABELS[order.status as OrderStatus]}
            </Badge>
          </div>

          <div className="space-y-1">
            <p className="text-sm text-muted-foreground flex items-center gap-1">
              <Calendar className="h-3.5 w-3.5" />
              Tilauspäivä
            </p>
            <p className="font-medium">{formatDate(order.order_date)}</p>
          </div>

          <div className="space-y-1">
            <p className="text-sm text-muted-foreground flex items-center gap-1">
              <Truck className="h-3.5 w-3.5" />
              Toimituspäivä
            </p>
            <p className="font-medium">{formatDate(order.delivery_date)}</p>
          </div>

          <div className="space-y-1">
            <p className="text-sm text-muted-foreground flex items-center gap-1">
              <Calendar className="h-3.5 w-3.5" />
              Asennuspäivä
            </p>
            <p className="font-medium">{formatDate(order.installation_date)}</p>
          </div>

          <div className="space-y-1">
            <p className="text-sm text-muted-foreground flex items-center gap-1">
              <Package className="h-3.5 w-3.5" />
              Tilauksen tyyppi
            </p>
            <p className="font-medium">
              {ORDER_TYPE_LABELS[order.order_type as OrderType]}
            </p>
          </div>

          <div className="space-y-1 col-span-2">
            <p className="text-sm text-muted-foreground">Toimitustapa</p>
            <p className="font-medium">
              {FULFILLMENT_TYPE_LABELS[order.fulfillment_type as FulfillmentType]}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
